import * as InterfacesDiscover from '../../../Interfaces/discover.interfaces';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dropzone from 'react-dropzone-uploader';
import Icon from '@material-ui/core/Icon';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import React from 'react';
const useStyles = makeStyles(theme => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    dropzone: {
        minWidth: '200px',
        border: 'none',
        margin: '0 auto',
        display: 'flex',
        justifyContent: 'center',
        position: 'relative',
    },
    inputLabel: {
        border: `2px dotted #cccccc`,
        transition: '.25s all',
        color: '#666',
        fontSize: theme.typography.fontSize,
        '&:hover': {
            cursor: 'pointer',
            borderColor: theme.palette.primary.main,
        },
    },
    inputLabelWithFiles: {
        margin: `${theme.spacing(3)}px auto`,
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
    labelPrimary: {
        fontSize: '14px',
    },
    labelSecondary: {
        fontSize: '12px',
    },
}));
const DropzoneWrapper = ({
    maxFiles = undefined,
    maxSizeBytes = 5000000,
    accept,
    discoverCardStatus,
    handleChangeStatus,
    previewComponent,
    initialFiles,
    multiple,
    labels = [],
    name,
}: InterfacesDiscover.IDropzoneWrapper) => {
    const classes = useStyles();

    const dropzoneRef = React.useRef<Dropzone>(null);
    return discoverCardStatus === 'saving' ? (
        <CircularProgress color="secondary" />
    ) : (
        <div data-cy={`Dropzone-${name}`}>
            <Dropzone
                accept={accept}
                addClassNames={{
                    dropzone: classes.dropzone,
                    inputLabel: classes.inputLabel,
                    inputLabelWithFiles: classes.inputLabelWithFiles,
                }}
                canRemove={true}
                initialFiles={initialFiles || []}
                maxFiles={maxFiles}
                maxSizeBytes={maxSizeBytes}
                multiple={multiple}
                onChangeStatus={handleChangeStatus}
                PreviewComponent={previewComponent ? previewComponent : undefined}
                ref={dropzoneRef}
            />
            <div style={{ paddingTop: '25px' }}>
                <List
                    subheader={
                        <Typography component="h4" paragraph variant="subtitle1">
                            <strong>File format & size</strong>
                        </Typography>
                    }
                >
                    {labels &&
                        labels.map((label: InterfacesDiscover.IDropzoneWrapperAcceptedLabels, idx: number) => {
                            return (
                                <ListItem key={idx}>
                                    <ListItemAvatar>
                                        <Icon style={{ width: '14px;' }}>{label.icon}</Icon>
                                    </ListItemAvatar>
                                    <ListItemText
                                        classes={{ primary: classes.labelPrimary, secondary: classes.labelSecondary }}
                                        primary={label.type}
                                        secondary={
                                            <div>
                                                {label && label.additional && label.additional.file && (
                                                    <Typography
                                                        classes={{ root: classes.labelSecondary }}
                                                        variant="subtitle1"
                                                    >
                                                        <strong>File size:</strong> {label.additional.file}
                                                    </Typography>
                                                )}
                                                {label && label.additional && label.additional.dimensions && (
                                                    <Typography
                                                        classes={{ root: classes.labelSecondary }}
                                                        variant="body2"
                                                    >
                                                        <strong>Dimensions:</strong>
                                                        <br></br> {label.additional.dimensions}
                                                    </Typography>
                                                )}
                                            </div>
                                        }
                                    />
                                </ListItem>
                            );
                        })}
                </List>
            </div>
        </div>
    );
};
export default DropzoneWrapper;
